"use client"

import { chakra } from "@chakra-ui/react"
import recipe from "./recipe"

export const Skeleton = chakra("div", recipe);
export default Skeleton
